import { useState } from "react";
import { motion } from "framer-motion";
import { servicedData } from "./constants";
import { useMediaQuery } from "react-responsive";
import close from "./esalab/icons8-close-100.png";
import menu from "./esalab/icons8-menu-100.png";
import "./navbar.css";
import logomain from "./esalab/ahk-removebg-preview.png";
import { useNavigate } from "react-router-dom";


export default function Navbar(props){
    const [state,setState] = useState(false);
    const [click,setclick] = useState(false);
    const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
    var [clicked,setClicked] = useState(false);
    const navigate = useNavigate();

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function handlepagetransition(event,href){
        event.preventDefault();
        const body=document.querySelector('body');
        body.classList.add('page-transition');
        await sleep(500);
        navigate(href);
        setClicked(false);
        setclick(false);
        await sleep(500);
        body.classList.remove('page-transition'); 
    }

    function changeclicked(){
        if(clicked==true){
            setClicked(false);
        }else{
            setClicked(true);
        }
    }
    function changeclick(){
        if(click==true){
            setclick(false);
        }else{
            setclick(true);
        }
    }
    const titlearr = [
        'Digital X-Ray',
        'Ultrasound',
        'Exercise Tolerance Test',
        'ECG-Electrocardiogram',
      ]
    return <div className="nasbar">
    {isMobile?<div className="mobnav">
        <img alt="menu" src={menu} className="menuicon" onClick={changeclicked}/>
        <div class="dropdown">
            <img src="data/icons/user_9131590.png" onClick={changeclick} alt="user"/>
            <div class="dropdown-content" style={click ? { display: "block" } : { display: "none" }}>
                <a href="/login" onClick={(e) => handlepagetransition(e, "/login")}>Login</a>
                <a href="/registerPatient" onClick={(e) => handlepagetransition(e, "/registerPatient")}>Register</a>
                <a href="/logout" onClick={(e) => handlepagetransition(e, "/logout")}>Logout</a>
            </div>
        </div>
    </div>:null}
            <motion.div className="sidebar" variants={
                {
                hidden:{display:"none",x:"-50vw"},
                visible:{display:"flex",x:"0vw"}
                }
            }
            animate={isMobile?clicked?"visible":"hidden":null} transition={{duration:0.5,delay:0.25}}
            >
            <img alt="close" className="menuicon close" src={close} onClick={changeclicked} />
                <div className="sidediv">
                        <a href="/" className="sideitem" onClick={(e)=>handlepagetransition(e,"/")}>HOME</a>
                        <a href="/about" className="sideitem" onClick={(e) => handlepagetransition(e, "/about")}>ABOUT US</a>
                        <a href="/contact" className="sideitem" onClick={(e) => handlepagetransition(e, "/contact")}>CONTACT US</a>
                        <a href="/book" className="sideitem" onClick={(e) => handlepagetransition(e, "/book")}>BOOK</a>
                        {props.authenticated?<div className="navigation">
                        <a href="/uploadReports" className="sideitem">UPLOAD REPORTS</a>
                        <a href="/registerPatient" className="sideitem">REGISTER PATIENT</a>
                        {props.admin?<div className="navigation"><a href="/checkBalance" className="sideitem">CHECK BALANCE</a>
                            <a href="/registerEmp" className="sideitem">REGISTER EMPLOYEE</a></div>:null}
                        </div>:null}
                        <a href="/reports" onClick={(e) => handlepagetransition(e, "/reports")} className="viewreportslink">VIEW REPORTS</a>
                </div>
            </motion.div>  
    {isMobile?null:<section id="home">
            <div class="info-box">
                <div class="contacts-tele">
                    <div class="tele2">
                        <a href="tel:03232195385"><img src="data/icons/phone.png" alt="phone"/>
                            <p>+92 3232195385</p>
                        </a>
                    </div>
                    <div class="tele2">
                        <a href="mailto:ahkportablexray@gmail.com"><img src="data/icons/premail-removebg-preview.png" alt="email"/>
                            <p>ahkportablexray@gmail.com</p>
                        </a>
                    </div>
                </div>
                <div class="icon-tele">
                    <div class="tele n1">
                        <a href="instagram.com"><img src="data/icons/instagram.png" alt="instagram"/></a>
                    </div>
                    <div class="tele n2">
                        <a href="facebook.com"><img src="data/icons/facebook.png" alt="facebook"/></a>
                    </div>
                    <div class="tele n3">
                        <a href="linkdin.com"><img src="data/icons/linkdin.png" alt="linkdin"/></a>
                    </div>
                    <div class="tele n4">
                        <a href="telegram.com"><img src="data/icons/telegram.png" alt="telegram"/></a>
                    </div>
                </div>
            </div>
            <div class="nassbar">
                <div class="logo">
                    <img src={logomain} alt="logo"/>
                </div>
                <div class="nav">
                    <nav class="nav-bar">
                        <ul>
                            <li><a href="/" onClick={(e)=>handlepagetransition(e,"/")}>HOME</a></li>
                            <li onMouseEnter={()=>setState(true)}><a href={null}>SERVICES</a></li>
                            <li><a href="/about" onClick={(e)=>handlepagetransition(e,"/about")}>ABOUT US</a></li>
                            <li><a href="/contact" onClick={(e)=>handlepagetransition(e,"/contact")}>CONTACT US</a></li>
                            <li><a href="/book" onClick={(e)=>handlepagetransition(e,"/book")}>BOOK</a></li>
                            <li><a href="/reports" onClick={(e)=>handlepagetransition(e,"/reports")} className="viewreportslink">VIEW REPORTS</a></li>
                            <li>
                                <div class="dropdown">
                                    <img src="data/icons/user_9131590.png" onClick={changeclick} alt="user"/>
                                    <div class="dropdown-content" style={click?{display:"block"}:{display:"none"}}>
                                        <a href="/login" onClick={(e)=>handlepagetransition(e,"/login")}>login</a>
                                        <a href="/registerPatient" onClick={(e)=>handlepagetransition(e,"/registerPatient")}>Register</a>
                                        <a href="/logout" onClick={(e)=>handlepagetransition(e,"/logout")}>logout</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section>}
    
    {isMobile?null:
        <div>
        {/* <Navigtion changeVisible={(s)=>{setState(s)}}/> */}
        <motion.div className="hiddenClass" animate={state?{opacity:1,y:"0vw"}:{opacity:0,y:"-5vw"}} transition={{duration:0.5,delay:0.2}} onMouseLeave={()=>setState(false)} style={{display:state?"flex":"none"}}>
        <div className="colOne">
                <h3>Home Services</h3>
                <a className="linkhidden">Nursing</a>
                <a className="linkhidden" href={"/"+servicedData[0].about} onClick={(e)=>handlepagetransition(e,"/"+servicedData[0].about)} >Portable X ray</a>
            </div>
            <div className="colOne">
                <h3>Radiology</h3>
                {titlearr.map((title,index)=>{
                    return <a className="linkhidden" href={"/"+servicedData[index].about} onClick={(e)=>handlepagetransition(e,"/"+servicedData[index].about)}>{title}</a>
                })}
            </div>
            <div className="colOne">
            <h3>Allied</h3>
                    <a className="linkhidden" href={"/"+servicedData[4].about} onClick={(e)=>handlepagetransition(e,"/"+servicedData[4].about)} >Physiotherapy</a>
            </div>
        </motion.div>
        </div>
    }
    
    </div>
}